import React from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import products from './Product'; 
import '../styles/Solutiongallery.css'
import ReactPlayer from 'react-player';
import prototypeimg from '../assest/Prototype Thumbnail.png'
import {Link} from 'react-router-dom'

const Solutiongallery = () => {
    //   const { id } = useParams(); // Get ID from the URL
    //   const product = products.find(p => p.id.toString() === id); // Match the product by ID

    //   if (!product) return <p>Product not found</p>;

    return (
        <>
            <div className='gallery-container ' id='gallery'>
                <div className='gallery-head'>
                    <h2 className='gallery'> Solution Gallery</h2>
                    <h2>HealthCare</h2>

                    <div className='gallery-wrapper'>
                       <Link to={"/coming-soon"}> <div className='gallery-box'>
                            <div className='gallery-video'>
                                <img src={prototypeimg}/>
                                {/* <ReactPlayer
                                    url="https://youtu.be/KJwYBJMSbPI?si=WcogdokoILZyrLiV"
                                    controls={true}

                                    width="100%"
                                    height="80%"

                                    className="video-player"
                                /> */}

                            </div>
                            <h2>Medical Billing Software</h2>
                            <p> Manage appointments, records, and reports with confidence and care.</p>
                        </div></Link>
                       <Link to={"/coming-soon"}>   <div className='gallery-box2'>
                            <div className='gallery-video'>
                                 <img src={prototypeimg}/>
                                {/* <ReactPlayer
                                    url="https://youtu.be/KJwYBJMSbPI?si=WcogdokoILZyrLiV"
                                    controls={true}

                                    width="100%"
                                    height="80%"

                                    className="video-player"
                                /> */}
                            </div>
                            <h2>Telemedicine Platforms</h2>
                            <p> Manage appointments, records, and reports with confidence and care.</p>
                        </div>
                        </Link>
                     <Link to={"/coming-soon"}>     <div className='gallery-box3'>
                            <div className='gallery-video'>
                                   <img src={prototypeimg}/>
                                {/* <ReactPlayer
                                    url="https://youtu.be/KJwYBJMSbPI?si=WcogdokoILZyrLiV"
                                    controls={true}

                                    width="100%"
                                    height="80%"

                                    className="video-player"
                                /> */}
                            </div>
                            <h2>Healthcare Mobile Apps</h2>
                            <p> Manage appointments, records, and reports with confidence and care.</p>
                        </div>
                        </Link>
                    </div>
                 
                </div>
            </div>

            <div className='gallery-container2'>
                <div className='gallery-head2'>
                    <h2> Education  </h2>

                    <div className='gallery-wrapper2'>
                         <Link to={"/coming-soon"}> <div className='gallery-box4'>
                            <div className='gallery-video2'>
                                   <img src={prototypeimg}/>
                                {/* <ReactPlayer
                                    url="https://youtu.be/KJwYBJMSbPI?si=WcogdokoILZyrLiV"
                                    controls={true}

                                    width="100%"
                                    height="80%"

                                    className="video-player"
                                /> */}
                            </div>
                            <h2>E-Learning Platforms</h2>
                            <p> Manage appointments, records, and reports with confidence and care.</p>
                        </div> </Link>
                       <Link to={"/coming-soon"}>   <div className='gallery-box5'>
                            <div className='gallery-video2'>
                                   <img src={prototypeimg}/>
                                {/* <ReactPlayer
                                    url="https://youtu.be/KJwYBJMSbPI?si=WcogdokoILZyrLiV"
                                    controls={true}

                                    width="100%"
                                    height="80%"

                                    className="video-player"
                                /> */}
                            </div>
                            <h2>Educational Mobile Apps</h2>
                            <p> Manage appointments, records, and reports with confidence and care.</p>
                        </div>
                        </Link>
                        <Link to={"/coming-soon"}>  <div className='gallery-box6'>
                            <div className='gallery-video2'>
                                   <img src={prototypeimg}/>
                                {/* <ReactPlayer
                                    url="https://youtu.be/KJwYBJMSbPI?si=WcogdokoILZyrLiV"
                                    controls={true}

                                    width="100%"
                                    height="80%"

                                    className="video-player"
                                /> */}
                            </div>
                            <h2>Student Information Systems (SIS)</h2>
                            <p> Manage appointments, records, and reports with confidence and care.</p>
                        </div>
                        </Link>
                    </div>
                    
                </div>
            </div>

            <div className='gallery-container3'>
                <div className='gallery-head3'>
                    <h2> Retail</h2>

                    <div className='gallery-wrapper3'>
                      <Link to={"/coming-soon"}>    <div className='gallery-box7'>
                            <div className='gallery-video3'>
                                   <img src={prototypeimg}/>
                                {/* <ReactPlayer
                                    url="https://youtu.be/KJwYBJMSbPI?si=WcogdokoILZyrLiV"
                                    controls={true}

                                    width="100%"
                                    height="80%"

                                    className="video-player"
                                /> */}
                            </div>
                            <h2>POS (Point of Sale) Solutions</h2>
                            <p> Manage appointments, records, and reports with confidence and care.</p>
                        </div>
                        </Link>
                       <Link to={"/coming-soon"}>   <div className='gallery-box8'>
                            <div className='gallery-video3'>
                                   <img src={prototypeimg}/>
                                {/* <ReactPlayer
                                    url="https://youtu.be/KJwYBJMSbPI?si=WcogdokoILZyrLiV"
                                    controls={true}

                                    width="100%"
                                    height="80%"

                                    className="video-player"
                                /> */}
                            </div>
                            <h2>Inventory & Stock Management </h2>
                            <p> Manage appointments, records, and reports with confidence and care.</p>
                        </div>
                        </Link>
                      <Link to={"/coming-soon"}>    <div className='gallery-box9'>
                            <div className='gallery-video3'>
                                   <img src={prototypeimg}/>
                                {/* <ReactPlayer
                                    url="https://youtu.be/KJwYBJMSbPI?si=WcogdokoILZyrLiV"
                                    controls={true}

                                    width="100%"
                                    height="80%"

                                    className="video-player"
                                /> */}
                            </div>
                            <h2>Retail Mobile Apps
</h2>
                            <p> Manage appointments, records, and reports with confidence and care.</p>
                        </div>
                        </Link>
                    </div>
                     
                </div>
            </div>

            <div className='gallery-container4'>
                <div className='gallery-head4'>
                    <h2>Professional   </h2>

                    <div className='gallery-wrapper4'>
                     <Link to={"/coming-soon"}>     <div className='gallery-box10'>
                            <div className='gallery-video4'> 
                                   <img src={prototypeimg}/>
                                {/* <ReactPlayer
                                url="https://youtu.be/KJwYBJMSbPI?si=WcogdokoILZyrLiV"
                                controls={true}

                                width="100%"
                                height="80%"

                                className="video-player"
                            /> */}
                            </div>
                            <h2>Project Tracking & Reporting Tools</h2>
                            <p> Manage appointments, records, and reports with confidence and care.</p>
                        </div>
                        </Link>
                         <Link to={"/coming-soon"}> <div className='gallery-box11'>
                            <div className='gallery-video4'> 
                                   <img src={prototypeimg}/>
                                {/* <ReactPlayer
                                url="https://youtu.be/KJwYBJMSbPI?si=WcogdokoILZyrLiV"
                                controls={true}

                                width="100%"
                                height="80%"

                                className="video-player"
                            /> */}
                            </div>
                            <h2>Business Website Development</h2>
                            <p> Manage appointments, records, and reports with confidence and care.</p>
                        </div>
                        </Link>
                      <Link to={"/coming-soon"}>    <div className='gallery-box12'>
                            <div className='gallery-video4'> 
                                   <img src={prototypeimg}/>
                                {/* <ReactPlayer
                                url="https://youtu.be/KJwYBJMSbPI?si=WcogdokoILZyrLiV"
                                controls={true}

                                width="100%"
                                height="80%"

                                className="video-player"
                            /> */}
                            </div>
                            <h2>Client Management Systems (CRM)</h2>
                            <p> Manage appointments, records, and reports with confidence and care.</p>
                        </div>
                        </Link>
                    </div>
                     
                </div>
            </div>

          

            <div className='gallery-container6'>
                <div className='gallery-head6'>
                    <h2>Startups   </h2>

                    <div className='gallery-wrapper6'>
                       <Link to={"/coming-soon"}>   <div className='gallery-box16'>
                            <div className='gallery-video6'>
                                   <img src={prototypeimg}/>
                                 {/* <ReactPlayer
                                url="https://youtu.be/KJwYBJMSbPI?si=WcogdokoILZyrLiV"
                                controls={true}

                                width="100%"
                                height="80%"

                                className="video-player"
                            /> */}
                            </div>
                            <h2>Startup Branding & UI/UX Design</h2>
                            <p> Manage appointments, records, and reports with confidence and care.</p>
                        </div>
                        </Link>
                     <Link to={"/coming-soon"}>     <div className='gallery-box17'>
                            <div className='gallery-video6'>
                                   <img src={prototypeimg}/>
                                 {/* <ReactPlayer
                                url="https://youtu.be/KJwYBJMSbPI?si=WcogdokoILZyrLiV"
                                controls={true}

                                width="100%"
                                height="80%"

                                className="video-player"
                            /> */}
                            </div>
                            <h2>Startup Website & Landing Page 
</h2>
                            <p> Manage appointments, records, and reports with confidence and care.</p>
                        </div>
                        </Link>
                       <Link to={"/coming-soon"}>   <div className='gallery-box18'>
                            <div className='gallery-video6'> 
                                   <img src={prototypeimg}/>
                                {/* <ReactPlayer
                                url="https://youtu.be/KJwYBJMSbPI?si=WcogdokoILZyrLiV"
                                controls={true}

                                width="100%"
                                height="80%"

                                className="video-player"
                            /> */}
                            </div>
                            <h2> Custom Web & Mobile App .</h2>
                            <p> Manage appointments, records, and reports with confidence and care.</p>
                        </div>
                        </Link>
                    </div>
                     <button
              className="healthcare-btn"
              onClick={() => {
                document.getElementById("contact").scrollIntoView({ behavior: "smooth" });
              }}
            >
             Contact Cauzen &nbsp;<span className="arrow"><i className="fas fa-arrow-right"></i></span>
            </button>
                </div>
            </div>


        </>
    );
};

export default Solutiongallery;
